<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>Follow the paths of two artists, Alexander Wainwright and Rinaldo, in a passionate, suspenseful tale of art, life, love, and liberation. For such different men in their art and personalities, the fundamental question is whether they can ever collaborate on a project.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?b92bda12